<template>
<v-row wrap class="ma-0">
    <v-col cols="12" md="11" lg="10" xl="10" text-subtitle-1 font-weight-medium >
        <!-- largre -->
        <v-row v-if="journal" class="hidden-sm-and-down ml-5 mr-5" justify="space-around">
            <a title="Institute of Mathematics CAS"
                href="https://math.cas.cz"
                class="blue--text text--darken-4">
                <span class="mb-1">Publisher</span>
                <v-img
                    :src="require('../../../assets/library/im-logo.gif')"
                    max-height="64"
                    contain
                    class="ma-0"
                ></v-img>
            </a>
            <a
            :href="journal.eudml"
            title="European Digital Mathematics Library"
            target="_blanc"
            class="blue--text text--darken-4">
            <span  class="mb-2 ml-5">Archive of old issues</span>
            <v-img
                :src="require('../../../assets/library/EUDMLlogo.png')"
                max-height="55"
                max-width="200"
                contain
                class="ma-0"
            ></v-img>
            </a>
            <a  title="DML"
                :href="journal.dml"
                target="_blanc"
                class="blue--text text--darken-4">
                <span class="mb-1">Archive of old issues</span>
                <v-img
                    :src="require('../../../assets/library/dmlczlogo.png')"
                    max-height="64"
                    contain
                    class="ma-0"
                ></v-img>
            </a>
        </v-row>
        <!-- small -->
        <v-row class="hidden-md-and-up" justify="center">
            <a title="Institute of Mathematics CAS"
                href="https://math.cas.cz"
                class="blue--text text--darken-4">
                <span class="mb-1">Publisher</span>
                <v-img
                    :src="require('../../../assets/library/im-logo.gif')"
                    max-height="64"
                    contain
                    class="ma-0"
                ></v-img>
            </a>
        </v-row>
        <!-- small -->
        <v-row v-if="journal" class="hidden-md-and-up my-7" justify="center">
            <a :href="journal.eudml"
                title="European Digital Mathematics Library"
                target="_blanc"
                class="blue--text text--darken-4">
                <span  class="mb-2 ml-5">Archive of old issues</span>
                <v-img
                    :src="require('../../../assets/library/EUDMLlogo.png')"
                    max-height="55"
                    max-width="200"
                    contain
                    class="ma-0"
                ></v-img>
            </a>
        </v-row>
        <!-- small -->
        <v-row v-if="journal" class="hidden-md-and-up" justify="center">
            <a  title="DML"
                :href="journal.dml"
                target="_blanc"
                class="blue--text text--darken-4">
                <span class="mb-1">Archive of old issues</span>
                <v-img
                    :src="require('../../../assets/library/dmlczlogo.png')"
                    max-height="64"
                    contain
                    class="ma-0"
                ></v-img>
            </a>
        </v-row>
    </v-col>
</v-row>
</template>
<script>
import {mapGetters} from 'vuex';
export default {
       computed:{
        ...mapGetters('library',{
            journal:'journal',
        })
    },
}
</script>
